import React from 'react';

import { Menu } from '@mui/material';
import { CheckMarkMenuItem } from 'src/components';
import { Apollo } from 'src/gql/generated';

export const accessLevelToDisplayNameMap = {
  [Apollo.WorkflowAccessLevel.Assignee]: 'Editor',
  [Apollo.WorkflowAccessLevel.Viewer]: 'Viewer',
  [Apollo.WorkflowAccessLevel.NoAccess]: 'No Access',
};

interface WorkflowAccessLevelMenuProps {
  anchorEl: HTMLElement | null;
  handleSelect: (accessLevel: Apollo.WorkflowAccessLevel) => void;
  onClose: () => void;
  open: boolean;
  value: Apollo.WorkflowAccessLevel | null;
  className?: string;
  disabled?: boolean;
}

const accessLevels = [
  Apollo.WorkflowAccessLevel.Assignee,
  Apollo.WorkflowAccessLevel.Viewer,
  Apollo.WorkflowAccessLevel.NoAccess,
] as const;

export function WorkflowAccessLevelMenu({
  anchorEl,
  className = '',
  disabled,
  handleSelect,
  onClose,
  open,
  value,
}: WorkflowAccessLevelMenuProps): JSX.Element | null {
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      className={className}
      open={open}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      onClose={onClose}
    >
      {accessLevels.map((accessLevel, index) => (
        <CheckMarkMenuItem
          key={index}
          disabled={disabled}
          selected={value === accessLevel}
          value={accessLevel}
          onClick={() => {
            onClose();
            handleSelect(accessLevel);
          }}
        >
          {accessLevelToDisplayNameMap[accessLevel]}
        </CheckMarkMenuItem>
      ))}
    </Menu>
  );
}
